import React from "react";
import { Dropdown, Menu } from "antd";
import Btn from "../Button";
import { Loader } from "react-feather";

const GenerateDropdown = ({ onGenerateAll, onGenerateSelected, onDownloadAll, onDownloadSelected, mainLoading }) => {
  const menu = (
    <Menu>
      <Menu.Item key="generate-all" onClick={onGenerateAll}>
        Generate All
      </Menu.Item>
      <Menu.Item key="generate-selected" onClick={onGenerateSelected}>
        Generate Selected
      </Menu.Item>
      <Menu.Item key="download-all" onClick={onDownloadAll}>
        Download All
      </Menu.Item>
      <Menu.Item key="download-selected" onClick={onDownloadSelected}>
        Download Selected
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={["hover"]} placement="bottomLeft">
      <div className="generate-dropdown-wrapper">
        <Btn attrBtn={{ color: "primary", disabled: mainLoading }}>
          <div className="d-flex align-items-center gap-2">
            <span>Generate</span>
            <i className="fa fa-angle-down m-l-10 dropdown-icon"></i>
            {mainLoading && <Loader className="custom-spin" />}
          </div>
        </Btn>
      </div>
    </Dropdown>
  );
};

export default GenerateDropdown;
